import { Link } from "react-router-dom";

export function GuidedLockedState() {
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-5">
      <p className="text-sm font-semibold text-slate-950">Guided Mode</p>
      <p className="mt-2 text-sm leading-6 text-slate-600">
        Guided Mode is included with Standard and Pro.
      </p>
      <Link
        to="/pricing"
        className="mt-4 inline-flex rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700"
      >
        Upgrade to unlock Guided Mode
      </Link>
    </div>
  );
}
